import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ReportDataModal extends BaseModel {
  static urlPath = "report_data";

  @attr("array") columns;
  @attr("number") count;
  @attr("string") queryTime;
  @attr("string") defaultLimit;
  @attr("string") description;
  @attr("string") displayName;
  @attr("string") next;
  @attr("string") previous;
  @attr("array") results;
  @attr("array") searchesBy;
  @attr("array") availableColumns;
  @attr("string") dataAccessPk;
}
